import { ActionType, EntityType, ModuleType } from "../../../queryKeyFactory";
export const subscriptionKeyFactory = {
  subscriptionList: (): [ModuleType, EntityType, 'packageList'] => ["onboarding", "subscription", 'packageList'],
  basisTypes: (): [ModuleType, EntityType] => [
    "onboarding",
    "subscription",
  ],
  addOnsList: (): [ModuleType, EntityType, string ] => [
    "onboarding",
    "subscription",
    "addOns"
  ],
   currentSubscription: (): [ModuleType, EntityType, string ] => [
    "onboarding",
    "subscription",
    "current"
  ],
  supportRequests: (): [ModuleType, EntityType, string ] => [
    "onboarding",
    "subscription",
    "supportRequests"
  ],
}